module.exports = __webpack_public_path__ + "img/checkbox_icon.aaf19fb3.svg";